import { get } from 'lodash';
import { RegulationDto } from '@tek-crm/backend/dist/application/regulation/dto/regulation.dto';

export const createAddon = (regulation: RegulationDto, path) =>
  regulation ? `по НТД: ${get(regulation, path) || '-'}` : undefined;
